import { FormField } from '@domgen/dgx-fe-forms/layout';

export interface CmsApplianceDetailsSteppedMultiPlanForm {
  applianceBuiltInCodeField: FormField;
  applianceCodeField: FormField;
  brandCodeField: FormField;
  extraAppliancesField: FormField;
  purchaseDateField: FormField;
  purchasePriceField: FormField;
  warrantyField: FormField;
}
